import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '@ibank-globals/language';
import { BaseComponent } from '../../../globals/classes/base.component';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'common-questions',
	template: require('./common-questions.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class CommonQuestionsComponent extends BaseComponent implements OnInit {
	public isEnglish: boolean = false;
	public multilanguage = AppSettings.multilanguage;
	public icon: string = 'nbg-logo';

	constructor(private router: Router, private _langSvc: LanguageService) {
		super();
	}
	public ngOnInit(): void {
		this._initSubscriptions();
	}

	backToMain(): void {
		this.router.navigate(['/']);
	}
	public toggleLanguage() {
		if (this.multilanguage === true) {
			this._langSvc.changeLanguage();
		}
	}

	private _initSubscriptions() {
		this.mortalize(this._langSvc.activeLanguage$).subscribe((lang) => {
			this.isEnglish = lang === 'en';
		});
	}
}
